import {
  Box, Card, CircularProgress, Typography,
} from '@mui/material';
import { useAppSelector } from '../../../app/hooks';
import { ReactComponent as Seller } from '../../../assets/svg/thatBook/moneyAdministratorNoColor.svg';

const CardTotalSellers = () => {
  const { generalStatistics, loadingGeneralStatistic } = useAppSelector(( state ) => state.dashboard );
  const { sellers } = generalStatistics;
  return (
    <Card sx={{ backgroundColor: '#0288D1', color: 'white', height: '100%' }}>
      <Box p={2} display="flex" justifyContent="space-between" alignItems="center">
        <Box>
          <Typography variant="h6">
            {loadingGeneralStatistic ? <CircularProgress size={24} color="inherit" /> : (
              <>
                {sellers.created}
              </>
            )}
          </Typography>
          <Typography variant="subtitle1">Vendedores</Typography>
        </Box>
        <Seller width={50} height={50} fill="white" />
      </Box>
    </Card>
  );
};

export default CardTotalSellers;
